import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { EnterpriseHero } from "@/components/enterprise/enterprise-hero-v2/src/enterprise-hero";
import { Play } from "@/libraries/wpl/foundations/src/icons/object/play";

const VideoLink = ({ handleCtaClick }: { handleCtaClick: () => void }) => {
    const buttonStyle = css({
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "center",
        "alignItems": "center",
        "gap": "8px",
        "textDecoration": "none",
        "color": "#006CEB",
        "fontFamily": "Charlie Text",
        "fontSize": "16px",
        "fontStyle": "normal",
        "fontWeight": "500",
        "lineHeight": "20px",
        "height": "20px",
        "background": "none",
        "border": "none",
        // Need to target inner svg path
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "path": {
            fill: "#006CEB"
        },
        "&:hover": {
            cursor: "pointer",
            color: "#1558BC",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            path: {
                fill: "#1558BC"
            }
        }
    });

    const dataEventProps = {
        "data-product-key": "enterprise",
        "data-event-component": "linkButton",
        "data-event-container": "heroSection",
        "data-event": "clicked",
        "data-label": "enterprise-hero-enterprise-cta",
        "data-label-english": "Watch video"
    };

    return (
        <>
            <button
                css={buttonStyle}
                {...dataEventProps}
                onClick={(e) => {
                    e.preventDefault();
                    handleCtaClick();
                }}
                onKeyDown={(e) => {
                    e.preventDefault();
                    handleCtaClick();
                }}
            >
                <Play size="22" />
                <span>
                    <FormattedMessage
                        id="enterprise-hero.tab.enterprise.cta"
                        defaultMessage={"Watch video"}
                    />
                </span>
            </button>
        </>
    );
};

export const EnterpriseTabContent = ({
    handleCtaClick
}: {
    handleCtaClick: () => void;
}) => {
    const intl = useIntl();

    return (
        <EnterpriseHero
            headerText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise.headerText",
                defaultMessage: "Build your system of work"
            })}
            bodyText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise.bodyText",
                defaultMessage:
                    "Bring your organization together on a flexible foundation that connects teams, goals, work, and knowledge"
            })}
            cta={<VideoLink handleCtaClick={handleCtaClick} />}
            color="dark"
            backgroundImgSrc={{
                xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-sm-107626183.webp",
                sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-md-2984500272.webp",
                md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-lg-2107118674.webp",
                lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-1621379571.webp"
            }}
        />
    );
};
